<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Page Title -->
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="header-pretitle">Settings</h6>
            <h1 class="header-title">TNA Period Management</h1>
          </div>
          <div class="col-auto">
            <button 
              class="btn btn-primary" 
              @click="openAddModal">
              <i class="fe fe-plus me-2"></i>
              Add TNA Period
            </button>
          </div>
        </div>
      </div>

      <!-- Table Card -->
      <div class="card mt-4">
        <div class="card-header">
          <h4 class="card-header-title">TNA Periods</h4>
        </div>

        <!-- Loading State -->
        <div v-if="isLoading" class="card-body text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="mt-2">Loading TNA periods...</p>
        </div>

        <!-- Vue Good Table -->
        <div v-else class="card-body">
          <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="periods"
            :totalRows="totalItems"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'created_at', type: 'desc' }
            }"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
              position: 'bottom',
              perPage: perPage,
              perPageDropdown: perPageOptions,
              dropdownAllowAll: false,
              nextLabel: 'Next',
              prevLabel: 'Prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page',
              allLabel: 'All'
            }"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChangeVGT"
            style-class="vgt-table border-0 table">
            <!-- Empty State -->
            <div slot="emptystate" class="text-center py-5">
              <i class="fe fe-calendar text-muted" style="font-size: 3rem;"></i>
              <p class="text-muted mt-2">No TNA periods found</p>
            </div>

            <!-- Custom Rows -->
            <template slot="table-row" slot-scope="props">
              <!-- No -->
              <span v-if="props.column.field == 'no'">
                {{ (currentPage - 1) * perPage + props.row.originalIndex + 1 }}
              </span>

              <!-- Period -->
              <span v-else-if="props.column.field == 'period'">
                <strong>{{ formatDate(props.row.start_date) }} - {{ formatDate(props.row.end_date) }}</strong>
              </span>

              <!-- Start Date -->
              <span v-else-if="props.column.field == 'start_date'">
                {{ formatDate(props.row.start_date) }}
              </span>

              <!-- End Date -->
              <span v-else-if="props.column.field == 'end_date'">
                {{ formatDate(props.row.end_date) }}
              </span>

              <!-- Status -->
              <span v-else-if="props.column.field == 'status'">
                <span 
                  class="badge"
                  :class="getPeriodStatus(props.row).class">
                  {{ props.row.vstatus }}
                </span>
              </span>

              <!-- Action -->
              <span v-else-if="props.column.field == 'action'">
                <button
                  class="btn btn-sm btn-warning"
                  @click="openEditModal(props.row)"
                  title="Edit Period">
                  <i class="fe fe-edit"></i>
                </button>
              </span>

              <!-- Default -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>

      <!-- Modal Add/Edit TNA Period -->
      <b-modal 
        v-model="isAdd" 
        :title="isEditMode ? 'Update TNA Period' : 'Create TNA Period'" 
        size="lg" 
        hide-footer>
        <div class="form-group">
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">Start Date</h5>
            </div>
            <div class="col-9">
              <input
                type="date"
                class="form-control mt-4"
                placeholder="Pilih Tanggal"
                v-model="periodForm.startDate"
                :disabled="isDisStartDate" />
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <h5 class="fw-bold mt-5">End Date</h5>
            </div>
            <div class="col-9">
              <input
                type="date"
                class="form-control mt-4"
                placeholder="Pilih Tanggal"
                v-model="periodForm.endDate" />
            </div>
          </div>
        </div>
        <b-button class="float-end" variant="primary" @click="savePeriod()">
          Submit
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import logic from './tna-period.logic.js';

export default {
  ...logic
}
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

.me-2 {
  margin-right: 0.5rem;
}

.badge-success {
  background-color: #00d97e;
}

.badge-info {
  background-color: #39afd1;
}

.badge-secondary {
  background-color: #95aac9;
}

/* DatePicker custom styles */
::v-deep .mx-datepicker {
  width: 100%;
}

::v-deep .mx-input {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: #12263f;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2ddec;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

::v-deep .mx-input:focus {
  color: #12263f;
  background-color: #fff;
  border-color: #95aac9;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(39, 128, 227, 0.25);
}

::v-deep .mx-input:hover {
  border-color: #95aac9;
}
</style>
